import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=38eb3864&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=38eb3864&prod&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=38eb3864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb3864",
  null
  
)

export default component.exports